export const FIELD_TITLES = {
  BeneficiaryAccountName: "Beneficiary Account Name",
  BankName: "Beneficiary Bank Name",
  AbaRoutingNumber: "ABA/Routing Number",
  BeneficiaryBankAccountNumber: "Beneficiary Bank Account Number",
  // Swift beneficiary-side additional fields
  Swift: "SWIFT",
  Iban: "IBAN",
  BankId: "Bank ID",
  BranchId: "Branch ID",
  // Intermediary
  IntermediaryAbaSwift: "Intermediary ABA/Swift",
  IntermediaryBankName: "Intermediary Bank Name",
  IntermediaryRoutingNumber: "Routing Number",
  IntermediaryPaymentMessage: "Payment Message",
  // Further Credit
  FurtherCreditLine1: "For Further Credit Line 1",
  FurtherCreditLine2: "For Further Credit Line 2",
  // Date
  DateInstructionsBecomeEffective: "Date Instructions Become Effective",
  // Free text
  AdditionalNote: "Additional Note",
  // Countries
  BankCountry: "Bank Country",
  BeneficiaryBankCountry: "Beneficiary Bank Country",
  IntermediaryBankCountry: "Intermediary Bank Country",
} as const;
